import React from "react";
import { useNavigate } from "react-router-dom";
import {
    Create,
    GetAllProduct,
    GetAllTask
} from "adminApi/LaundryItemCostApi/LaundryItemCost.js";
import { validateForm } from "utils/validation";
import { LaundryItemCostRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddLaundryItemCostForm from "./Componates/AddLaundryItemCostForm";
import fields from "../json/LaundryItemCostFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";

const AddLaundryItemCost = () => {

    const navigate = useNavigate();
    const { formdata } = fields;

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    // HandleInputChange
    const { values, errors, handleChange, setErrors } = useFormChange(
        initialValues,
        LaundryItemCostRules
    );

    const { data: ProductOptions = [] } = useFetchAllData(GetAllProduct);

    const { data: TaskOptions = [] } = useFetchAllData(GetAllTask);

    // Form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
            return await Create({ data: formData });
        },
        (vals) => {
            const err = validateForm(vals, LaundryItemCostRules)
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Laundry Item Cost Created Successfully"
    );

    return (
        <>
            {(loadingSubmit) && <Spinner isSpinner={true} />}
            <AddLaundryItemCostForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Create Laundry Item Cost"
                ProductOptions={ProductOptions}
                TaskOptions={TaskOptions}
            />
        </>
    );
};

export default AddLaundryItemCost;
